module.exports = __webpack_public_path__ + "media/assets/google-f99c98b7070903cda1e6d8f43d3419c7.svg";